import script from "./NotificationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=1465475d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1465475d"]])

export default __exports__